import type React from 'react';
import { Badge } from '@fluentui/react-components';
import { TagRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import type { IncidentTags } from 'types';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalXS,
    alignItems: 'center',
  },
});

interface IncidentTagBadgesProps {
  tags?: IncidentTags | null;
}

export const IncidentTagBadges: React.FC<IncidentTagBadgesProps> = ({ tags }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  if (!tags || (!tags.isCritical && tags.nis2Categories.length === 0)) {
    return null;
  }

  return (
    <span className={styles.root}>
      {tags.isCritical && (
        <Badge
          color="danger"
          appearance="filled"
          icon={<TagRegular />}
          size="large"
        >
          {t('statusPanel.tags.critical')}
        </Badge>
      )}
      {tags.nis2Categories.map((cat) => (
        <Badge
          key={cat}
          color="brand"
          appearance="filled"
          icon={<TagRegular />}
          size="large"
        >
          {t('statusPanel.tags.nis2')}: {cat}
        </Badge>
      ))}
    </span>
  );
};
